module.exports =  {
    bindings: {},
    controller: customsRulingsListController,
    templateUrl: 'cross/components/customs-rulings-list.html'
}

customsRulingsListController.$inject = [
    'crossDataService'
];

function customsRulingsListController(
    crossDataService
) {
    var vm = {
        service: crossDataService,
        changeActiveRuling: changeActiveRuling,
        isLoading: false,
        loadMore: loadMore
    };
    return vm;

    function loadMore() {
        vm.isLoading = true;
        crossDataService.loadMoreRulings().then(function () {
            vm.isLoading = false;
        });
    }

    function changeActiveRuling(rulingNumber, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        crossDataService.changeActiveRuling(rulingNumber);
    }
}